import type { Transition } from "history";
import { useContext, useEffect } from "react";
import type { Navigator } from "react-router-dom";
import { UNSAFE_NavigationContext } from "react-router-dom";

type NavigatorWithBlock = Navigator & { block: (blocker: any) => () => void };

export const usePrompt = (message: string, when: boolean) => {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const blocker = (tx: Transition) => {
    if (window.confirm(message)) {
      tx.retry();
    }
  };

  useEffect(() => {
    if (!when) return;

    // This is a bit of a hack to allow us to safely call navigator.block
    const unblock = (navigator as NavigatorWithBlock).block(
      (tx: Transition) => {
        const autoUnblockingTx = {
          ...tx,
          retry() {
            unblock();
            tx.retry();
          },
        };

        blocker(autoUnblockingTx);
      },
    );

    return unblock;
  }, [navigator, blocker, when]);
};
